import React, { useState, useEffect } from 'react';
import { ColDiv, RowDiv, Text } from 'styles';
import styled from 'styled-components';
import { NoticeList } from 'components/common/NoticeList';
import { Icon } from 'components/common/Icon';
import { BOARD_NOTICE_MODULE_NO } from 'data/constants';

import boardService from 'services/board/board-service';

export function MainCommunity({ list, navigate }) {
  const filterList = ['ALL', 'NOTICE', 'NEWS'];
  const [selectedFilter, setSelectedFliter] = useState('ALL');
  const [hover, setHover] = useState(false);

  const [noticeList, setNoticeList] = useState();
  const [loadingNotice, setLoadingNotice] = useState(true);

  useEffect(() => {
    async function fetchNotices() {
      let data = [];

      try {
        const response = await boardService.listContents(BOARD_NOTICE_MODULE_NO, 1, 4);

        if (response) {
          if (response.rows) {
            data = response.rows;
          }
        }
      } catch(e) {
        console.error(e);
      }

      setNoticeList(data);
      setLoadingNotice(false);
    }

    fetchNotices()
    return () => setLoadingNotice(true);
  }, []);

  return (
    <ColDiv $gap={24}>
      <FilterContainer $justifyContent="flex-end" $mJustifyContent="center" $gap={24}>
        {/* {filterList.map((filter, index) => (
          <FilterButton
            key={`filter_${index}`}
            onClick={() => setSelectedFliter(filter)}
            $active={selectedFilter === filter}
          >
            {selectedFilter === filter && <Circle />}
            {filter}
          </FilterButton>
        ))} */}
        <RowDiv
          $alignItems="center"
          $gap={6}
          onMouseOver={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          $cursor="pointer"
          onClick={() => navigate('/community/notice')}
        >
          <Text $type="b7" $lineHeight={1} $color={(hover && 'secondary') || 'secondary300'} $fontWeight={500}>
            MORE
          </Text>
          <Icon name="more" $width={20} $height={20} $padding="2px" />
        </RowDiv>
      </FilterContainer>
      <NoticeList list={noticeList} hideUserName hideDownloadFile onClick={(item) => {
        navigate(`/community/notice/view?contentNo=${item.contentNo}`, { state: { contentNo : item.contentNo } });
      }}/>
    </ColDiv>
  );
}

const FilterContainer = styled(RowDiv)`
  @media ${({ theme }) => theme.device.mobile} {
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.13);
    border-radius: 60px;
    padding: 8px 0;
  }
`;

const Circle = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.device.mobile} {
    width: 8px;
    height: 8px;
  }
`;

const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  transition: all 150ms ease;
  color: ${({ theme, $active }) => !$active && theme.colors.secondary300};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;
